export const gaEvent = (event_name, event_action, event_label, record_id) => {
  if (window.gtag) {
    const params = {
      event_action,
      event_label,
      transport_type: "beacon",
    };

    if (record_id !== undefined && record_id !== null && record_id !== "") {
      params.record_id = record_id;
    }

    window.gtag("event", event_name, params);
  }
};
